import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import { BLOG_URL } from "./data/categories";

// These paths used to render placeholder category pages that never worked.
// The content they promised lives on the blog, so anyone arriving on a stale
// link or bookmark gets forwarded instead of hitting a 404.
const RETIRED_PATHS = {
  "/blog": BLOG_URL,
  "/mental-health": `${BLOG_URL}/category/health/`,
  "/life-tips": `${BLOG_URL}/advice`,
  "/recipes": BLOG_URL,
  "/hobbies": BLOG_URL,
};

function App() {
  return (
    <Router>
      <div className="site-container">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            {Object.entries(RETIRED_PATHS).map(([path, target]) => (
              <Route
                key={path}
                path={path}
                element={<ExternalRedirect to={target} />}
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

// Sends the browser to another host. replace() keeps the dead path out of the
// back-button history so returning here doesn't bounce straight out again.
function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="page-container">
      <div className="page-body">
        <p>
          Taking you to <a href={to}>the blog</a>&hellip;
        </p>
      </div>
    </div>
  );
}

// 404 Not Found component
function NotFound() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">404 - Page Not Found</h1>
      </div>
      <div className="page-body">
        <p>Sorry, the page you're looking for doesn't exist.</p>
        <p>
          <Link to="/">Return to homepage</Link> or{" "}
          <a href={BLOG_URL} target="_blank" rel="noopener noreferrer">
            browse the blog
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default App;
